import { motion } from 'framer-motion';
import { processo } from '../lib/siteConfig';

export const Process = () => {
  return (
    <section
      id="processo"
      className="py-20 lg:py-28 bg-[#111]"
      data-testid="process-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="inline-block text-[#FF6B00] font-semibold uppercase tracking-wider text-sm mb-4">
            Processo de Trabalho
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Como <span className="text-[#FF6B00]">Trabalhamos</span>
          </h2>
          <p className="text-lg text-[#999]">
            Nosso processo é simples, transparente e focado em entregar 
            o melhor resultado com total segurança.
          </p>
        </motion.div>
        
        {/* Process Steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {processo.map((step, index) => (
            <motion.div
              key={step.numero}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="relative text-center"
              data-testid={`process-step-${index + 1}`}
            >
              {/* Number */}
              <div className="relative inline-block mb-6">
                <span className="text-8xl lg:text-9xl font-bold text-[#222] font-['Oswald']">
                  {step.numero}
                </span>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 bg-[#FF6B00] flex items-center justify-center shadow-lg shadow-[#FF6B00]/30">
                    <span className="text-black font-bold text-xl">{parseInt(step.numero)}</span>
                  </div>
                </div>
              </div>
              
              {/* Content */}
              <h3 className="text-xl lg:text-2xl font-bold text-white mb-4">
                {step.titulo}
              </h3>
              <p className="text-[#999] leading-relaxed max-w-sm mx-auto">
                {step.descricao}
              </p>
              
              {/* Connector Line (desktop only) */}
              {index < processo.length - 1 && (
                <div className="hidden md:block absolute top-16 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-[#FF6B00]/50 to-transparent" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
